import React from 'react';

let AuthContext = React.createContext(null);

export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;
export default AuthContext;
